<template>
  <div>
    <v-speed-dial v-model="fab" bottom right direction="top" outline>
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab outlined>
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else> mdi-hammer-screwdriver </v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="green"
        @click="bulkDialog = true"
        v-if="selected.length"
        outlined
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn fab dark small color="indigo" @click="formDialog = true" outlined>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-card outlined class="pa-10 mb-10">
      <v-card-title>Filtres</v-card-title>
      <v-card-text class="pa-0">
        <v-container>
          <v-row>
            <v-col
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Types"
                :items="filters.types"
                v-model="selectedFilters.types"
              ></v-select
            ></v-col>
            <v-col
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Covoiturage"
                :items="filters.carpool"
                v-model="selectedFilters.carpool"
              ></v-select
            ></v-col>
            <v-col
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Prioritaire"
                :items="filters.prioritary"
                v-model="selectedFilters.prioritary"
              ></v-select
            ></v-col>
            <v-col
              v-if="['/calculees', '/historique'].indexOf($route.path) > -1"
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Droit au macaron"
                :items="filters.allowed"
                v-model="selectedFilters.allowed"
              ></v-select
            ></v-col>
            <v-col
              v-if="['/calculees', '/historique'].indexOf($route.path) > -1"
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Nbre de points"
                :items="filters.points"
                v-model="selectedFilters.points"
              ></v-select
            ></v-col>
            <v-col
              v-if="['/calculees', '/historique'].indexOf($route.path) > -1"
              ><v-select
                small-chips
                multiple
                outlined
                dense
                label="Statuts"
                :items="filters.statuses"
                v-model="selectedFilters.statuses"
              ></v-select
            ></v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined @click="resetFilters">Réinitialiser les filtres</v-btn>
      </v-card-actions>
    </v-card>
    <v-card outlined class="pa-10">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
          outlined
          dense
          class="mb-6"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="
          type === 'pending'
            ? requests.filter((r) => r.status === 'pending')
            : requests.filter((r) => r.status !== 'pending')
        "
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="elevation-0"
        locale="fr-CH"
        :search="search"
        show-select
        single-select
        v-model="selected"
        :footer-props="{
          itemsPerPageOptions: [10, 30, 50],
          itemsPerPageText: 'Élements par page',
        }"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot justification: possible according to vuetify documentation -->
        <template v-slot:body="{ items }">
          <tbody class="text-left">
            <tr v-for="item in items" :key="item._id">
              <td>
                <v-checkbox
                  v-model="selected"
                  :value="item._id"
                  style="margin: 0px; padding: 0px"
                  hide-details
                />
              </td>
              <td @click="editItem(item)">
                {{ item.updates ? item.updates.lastname : item.lastname }}
              </td>
              <td @click="editItem(item)">
                {{ item.updates ? item.updates.firstname : item.firstname }}
              </td>
              <td @click="editItem(item)">
                {{ item.updates ? item.updates.type : item.type }}
              </td>
              <td @click="editItem(item)">
                {{
                  item.validable === null ? "En attente de validation" : "OK"
                }}
              </td>
              <td @click="editItem(item)">
                {{ checkIfPrioritary(item) }}
              </td>
              <td @click="editItem(item)">
                {{
                  (item &&
                    item.carpool &&
                    item.updates &&
                    item.updates.carpool === item.carpool) ||
                  (item.updates && item.updates.carpool)
                    ? "OUI"
                    : "NON"
                }}
              </td>
              <td @click="editItem(item)">
                {{ item.computedValues ? item.computedValues.pt_total : "-" }}
              </td>
              <td @click="editItem(item)">
                {{
                  item.computedValues
                    ? item.computedValues.droit_au_macaron
                    : "-"
                }}
              </td>
              <td @click="editItem(item)">
                <v-chip
                  color="grey"
                  text-color="white"
                  v-if="item.status === 'pending'"
                  small
                  >À traiter</v-chip
                >
                <v-chip
                  small
                  color="orange"
                  text-color="white"
                  v-if="item.status === 'processing'"
                  >En attente</v-chip
                >
                <v-chip
                  small
                  color="orange"
                  text-color="white"
                  v-if="item.status === 'compute-pending'"
                  >À calculer</v-chip
                >
                <v-chip
                  small
                  color="green lighten-4"
                  text-color="white"
                  v-if="item.status === 'calculated'"
                  >Calculée</v-chip
                >
                <v-chip
                  small
                  color="green"
                  text-color="white"
                  v-if="item.status === 'accepted'"
                  >Acceptée</v-chip
                >
                <v-chip
                  small
                  color="red"
                  text-color="white"
                  v-if="item.status === 'rejected'"
                  >Refusée</v-chip
                >
                <v-chip
                  small
                  color="grey lighten-1"
                  text-color="white"
                  v-if="item.status === 'canceled'"
                  >Annulée</v-chip
                >
              </td>

              <td @click="editItem(item)">{{ item.createdAt | formatDate }}</td>
              <td
                @click="editItem(item)"
                class="text-center"
                v-if="
                  (item.computedValues && item.computedValues.descr) ||
                  (item.bi && item.bi.siteWarning) ||
                  (item.bi && item.bi.typeWarning) ||
                  (item.duplicates && item.duplicates.length)
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="grey" dark v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    [
                      item.computedValues
                        ? item.computedValues.descr
                        : undefined,
                      item.bi && item.bi.siteWarning ? "site" : undefined,
                      item.bi && item.bi.typeWarning ? "type" : undefined,
                      item.duplicates && item.duplicates.length
                        ? "doublon"
                        : undefined,
                    ]
                      .filter((x) => x)
                      .join(", ")
                  }}</span>
                </v-tooltip>
              </td>
              <td @click="editItem(item)" class="text-center" v-else>-</td>
            </tr>
          </tbody>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot justification: possible according to vuetify documentation -->
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }"
          >{{ pageStart }}-{{ pageStop }} de {{ itemsLength }}</template
        >
      </v-data-table>

      <v-btn
        block
        outlined
        @click="triggerCalculation"
        :loading="submitting"
        v-if="this.$route.path === '/a-calculer'"
        :disabled="!selected.length"
        >Lancer le calcul des points
        <span v-if="selected.length">({{ selected.length }})</span></v-btn
      >

      <v-dialog
        v-model="bulkDialog"
        width="60%"
        @click:outside="closeBulkdialog"
      >
        <v-card class="pa-10">
          <v-card-title>Mise à jour du statut</v-card-title>
          <v-card-text>
            Pour les {{ selected.length }} éléments sélectionnés.
            <v-select
              label="Statut"
              :items="status"
              v-model="bulkStatus"
              outlined
              dense
              class="mt-3"
            ></v-select>

            <v-checkbox
              label="Envoyer un mail de confirmation"
              v-model="sendEmail"
              v-if="['accepted', 'rejected'].indexOf(bulkStatus) > -1"
            ></v-checkbox>
            <v-select
              outlined
              dense
              label="Modèle de mail"
              :items="emails"
              item-text="title"
              :item-value="(item) => item"
              v-model="selectedEmail"
              v-if="
                ['accepted', 'rejected'].indexOf(bulkStatus) > -1 && sendEmail
              "
            ></v-select>
            <v-textarea
              v-if="
                ['accepted', 'rejected'].indexOf(bulkStatus) > -1 &&
                sendEmail &&
                selectedEmail
              "
              label="Description du modèle"
              v-model="selectedEmail.description"
              disabled
              auto-grow
              outlined
              dense
            ></v-textarea>
            <v-text-field
              label="Objet"
              outlined
              dense
              v-model="selectedEmail.subject"
              v-if="
                ['accepted', 'rejected'].indexOf(bulkStatus) > -1 &&
                sendEmail &&
                selectedEmail
              "
            ></v-text-field>
            <tiptap-vuetify
              v-model="selectedEmail.html"
              :extensions="extensions"
              v-if="
                ['accepted', 'rejected'].indexOf(bulkStatus) > -1 &&
                sendEmail &&
                selectedEmail
              "
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="closeBulkdialog" :disabled="submitting"
              >Annuler</v-btn
            >
            <v-btn outlined text @click="updateStatuses" :loading="submitting"
              >Mettre à jour</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="formDialog" @click:outside="closeFormDialog">
        <v-card class="pa-10">
          <v-card-title>Ajout d'une nouvelle demande</v-card-title>
          <v-card-text>
            <park-base-form
              :closeFormDialog="closeFormDialog"
              :updateRequests="updateRequests"
              :formDialog="formDialog"
              :openSnackbar="openSnackbar"
              :years="years"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog"
        content-class="admin-dialog"
        @click:outside="close"
      >
        <v-card>
          <v-card-text>
            <v-container>
              <v-row class="text-center">
                <v-col cols="12" sm="12" class="headline">
                  Récapitulatif de la demande
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  class="subtitle-1"
                  :class="{
                    'red lighten-4': shouldHighlightTotal(editedItem),
                  }"
                >
                  Droit au macaron :
                  {{
                    editedItem.computedValues
                      ? editedItem.computedValues.droit_au_macaron
                      : "-"
                  }}
                </v-col>
                <v-col cols="12" sm="12" class="headline">
                  <v-select
                    label="Statut"
                    :items="status"
                    v-model="editedItem.status"
                    outlined
                    dense
                  ></v-select>
                  <v-col cols="12" sm="12" class="subtitle-1">
                    <v-btn outlined dense @click="downloadReport" class="mx-3"
                      >Fiche récapitulative</v-btn
                    >
                    <v-btn
                      outlined
                      dense
                      :to="`/notifications?request=${editedItem._id}`"
                      class="mx-3"
                      >Voir les notifications</v-btn
                    >
                  </v-col>
                  <v-checkbox
                    label="Envoyer un mail de confirmation"
                    v-model="sendEmail"
                    v-if="
                      ['accepted', 'rejected'].indexOf(editedItem.status) > -1
                    "
                  ></v-checkbox>
                  <div class="text-left body-2">
                    <v-select
                      outlined
                      dense
                      label="Modèle de mail"
                      :items="emails"
                      item-text="title"
                      :item-value="(item) => item"
                      v-model="selectedEmail"
                      v-if="
                        ['accepted', 'rejected'].indexOf(editedItem.status) >
                          -1 && sendEmail
                      "
                    ></v-select>
                    <v-textarea
                      v-if="
                        ['accepted', 'rejected'].indexOf(editedItem.status) >
                          -1 &&
                        sendEmail &&
                        selectedEmail
                      "
                      label="Description du modèle"
                      v-model="selectedEmail.description"
                      disabled
                      auto-grow
                      outlined
                      dense
                    ></v-textarea>
                    <v-text-field
                      label="Objet"
                      outlined
                      dense
                      v-model="selectedEmail.subject"
                      v-if="
                        ['accepted', 'rejected'].indexOf(editedItem.status) >
                          -1 &&
                        sendEmail &&
                        selectedEmail
                      "
                    ></v-text-field>
                    <tiptap-vuetify
                      v-model="selectedEmail.html"
                      :extensions="extensions"
                      v-if="
                        ['accepted', 'rejected'].indexOf(editedItem.status) >
                          -1 &&
                        sendEmail &&
                        selectedEmail
                      "
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <div class="subtitle-1">Critères spéciaux</div>
                  <v-card outlined>
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Enfant à charge</td>
                              <td>
                                {{
                                  editedItem.updates
                                    ? editedItem.updates.children
                                      ? "oui"
                                      : "non"
                                    : editedItem.children
                                    ? "oui"
                                    : "non"
                                }}
                              </td>
                              <td>
                                {{
                                  editedItem.children &&
                                  typeof editedItem.childrenValidated ===
                                    "boolean"
                                    ? editedItem.childrenValidated
                                      ? "validé"
                                      : "refusé"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Déplacements professionnels fréquents<v-icon
                                  class="ml-2"
                                  >mdi-seal</v-icon
                                >
                              </td>
                              <td>
                                {{
                                  editedItem.updates
                                    ? editedItem.updates.corporate
                                      ? "oui"
                                      : "non"
                                    : editedItem.corporate
                                    ? "oui"
                                    : "non"
                                }}
                              </td>
                              <td>
                                {{
                                  editedItem.corporate &&
                                  typeof editedItem.corporateValidated ===
                                    "boolean"
                                    ? editedItem.corporateValidated
                                      ? "validé"
                                      : "refusé"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Déplacements pour des raisons médicales
                                fréquents<v-icon class="ml-2">mdi-seal</v-icon>
                              </td>
                              <td>
                                {{
                                  editedItem.updates
                                    ? editedItem.updates.health
                                      ? "oui"
                                      : "non"
                                    : editedItem.health
                                    ? "oui"
                                    : "non"
                                }}
                              </td>
                              <td>
                                {{
                                  editedItem.health &&
                                  typeof editedItem.healthValidated ===
                                    "boolean"
                                    ? editedItem.healthValidated
                                      ? "validé"
                                      : "refusé"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Covoiturage</td>
                              <td>
                                {{
                                  editedItem.carpool ||
                                  (editedItem.updates &&
                                    editedItem.updates.carpool)
                                    ? "oui"
                                    : "non"
                                }}
                              </td>
                              <td>-</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>

                  <div
                    v-if="
                      editedItem.computedValues &&
                      editedItem.computedValues.previousRequests &&
                      editedItem.idisa !== 'no-idisa'
                    "
                  >
                    <div class="subtitle-1 mt-5">Demandes précédentes</div>
                    <v-card outlined>
                      <v-card-text>
                        <div
                          v-for="(pr, index) in editedItem.computedValues
                            .previousRequests"
                          :key="index"
                          class="mt-3"
                        >
                          <div>
                            <strong>{{ pr.year }}</strong>
                          </div>
                          <div>
                            Droit au macaron : {{ pr.droit_au_macaron }}
                          </div>
                          <div>({{ pr.pt_total }} points)</div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <div class="subtitle-1">Calcul des points</div>
                  <v-card outlined>
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Enfants à charge</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_enfants
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Covoiturage</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_cov
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Accessibilité mobilité douce</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_mob_douce
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Accessibilité TP - Durée du déplacement (porte à
                                porte)
                              </td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_duree_dep
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Accessibilité TP - Correspondances</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .pt_correspondances
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Accessibilité TP - Proximité d'un arrêt</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .pt_proximite_arret
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Accessibilité TP - Fréquence</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_frequence
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td class="subtitle-2">Total</td>
                              <td>
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.pt_total
                                    : "-"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>

                  <div
                    v-if="
                      (editedItem.computedValues &&
                        editedItem.computedValues.descr) ||
                      (editedItem.bi &&
                        (editedItem.bi.siteWarning ||
                          editedItem.bi.rate ||
                          editedItem.bi.typeWarning)) ||
                      (editedItem.duplicates && editedItem.duplicates.length)
                    "
                  >
                    <div class="subtitle-1 mt-3">Commentaires</div>
                    <v-card outlined>
                      <v-card-text class="text-center">
                        <div
                          v-if="
                            editedItem.computedValues &&
                            editedItem.computedValues.descr
                          "
                        >
                          {{ editedItem.computedValues.descr }}
                        </div>
                        <div v-if="editedItem.bi && editedItem.bi.siteWarning">
                          Incohérence site ({{ editedItem.bi.site }})
                        </div>
                        <div v-if="editedItem.bi && editedItem.bi.typeWarning">
                          Incohérence type ({{ editedItem.bi.type }})
                        </div>
                        <div v-if="editedItem.bi && editedItem.bi.rate">
                          Taux d'activité : {{ editedItem.bi.rate }} %
                        </div>
                        <div v-if="shouldHighlightTotal(editedItem)">
                          Droit au macaron précédent
                        </div>
                        <div
                          v-if="
                            editedItem.duplicates &&
                            editedItem.duplicates.length
                          "
                        >
                          <div class="subtitle-2 mt-2">Doublons</div>
                          <div
                            v-for="dup in editedItem.duplicates"
                            :key="dup._id"
                          >
                            {{ dup.firstname }} {{ dup.lastname }} ({{
                              dup.createdAt | formatDate
                            }}
                            |
                            {{
                              status.find((s) => s.value === dup.status).text
                            }})
                          </div>
                        </div>
                      </v-card-text></v-card
                    >
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <div class="subtitle-1">Transports publics</div>
                  <v-card outlined>
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Temps de trajet minimum</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.tp_trajet_min +
                                      " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Temps de trajet moyen</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.tp_trajet_moy +
                                      " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Proximité arrêt minimum</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .tp_proximite_arret_min + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Proximité arrêt moyen</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .tp_proximite_arret_moy + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Proximité arrêt moyen</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .tp_proximite_arret_moy_metres + " m"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Fréquence</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.tp_frequence +
                                      "/h"
                                    : "-"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                  <div class="subtitle-1 mt-3">Mobilité douce</div>
                  <v-card outlined>
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Distance</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.mob_douce_m +
                                      " m"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Temps de trajet aller</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .mob_douce_aller + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Temps de trajet retour</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .mob_douce_retour + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                  <div class="subtitle-1 mt-3">Voiture personnelle</div>
                  <v-card outlined>
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Distance</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.voiture_m + " m"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Temps de trajet</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues.voiture_trajet +
                                      " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                  <div class="subtitle-1 mt-3" v-if="editedItem.carpool">
                    Covoiturage
                  </div>
                  <v-card outlined v-if="editedItem.carpool">
                    <v-card-text class="text-left">
                      <v-simple-table outlined v-if="editedItem">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Distance</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? editedItem.computedValues
                                        .cov_travel_distance + " m"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Temps de trajet</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? Math.round(
                                        editedItem.computedValues
                                          .cov_travel_time
                                      ) + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Différence temps trajet</td>
                              <td class="text-right">
                                {{
                                  editedItem.computedValues
                                    ? Math.round(
                                        editedItem.computedValues
                                          .cov_diff_travel_time
                                      ) + " min"
                                    : "-"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider class="my-10"></v-divider>
              <v-row class="mt-5">
                <v-col cols="12" sm="6">
                  <div class="title mb-4">Demande originale</div>
                  <park-form
                    :park="editedItem"
                    v-if="editedItem.address"
                    :readOnly="true"
                    :openSnackbar="openSnackbar"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="title mb-4">Mises à jour</div>
                  <park-form
                    :park="editedItem.updates"
                    v-if="editedItem.address"
                    :readOnly="false"
                    :openSnackbar="openSnackbar"
                  />
                </v-col>
                <v-col cols="12" sm="2"> </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    dense
                    label="Commentaires"
                    v-model="editedItem.comments"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="close" :disabled="submitting"
              >Annuler</v-btn
            >
            <v-btn outlined text @click="save" :loading="submitting"
              >Mettre à jour</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar.visible"
        :bottom="true"
        :left="true"
        :color="snackbar.color"
        dense
        >{{ snackbar.text }}</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { parseISO, format, isAfter } from "date-fns";
import ParkForm from "@/components/ParkForm";
import ParkBaseForm from "./ParkBaseForm.vue";
import { debounce } from "lodash";
import fileDownload from "js-file-download";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  props: ["type", "year", "years", "emails"],
  components: { ParkForm, ParkBaseForm, TiptapVuetify },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      sendEmail: false,
      selectedEmail: undefined,
      fab: false,
      dialog: false,
      bulkDialog: false,
      bulkStatus: "",
      formDialog: false,
      total: 0,
      requests: [],
      loading: true,
      submitting: false,
      options: {},
      editedIndex: -1,
      editedItem: {},
      editableItem: { address: {} },
      selected: [],
      snackbar: {
        visible: false,
        color: "",
        text: "",
      },
      filters: {
        types: ["Apprenti", "Assistant étudiant", "Collaborateur", "Étudiant"],
        special: ["En attente de validation", "OK"],
        prioritary: ["OUI", "NON"],
        carpool: ["OUI", "NON"],
        allowed: ["Oui", "Non"],
        points: Array.from(Array(20).keys()),
        statuses: ["Acceptée", "Refusée", "Annulée"],
      },
      selectedFilters: {
        types: [],
        prioritary: [],
        carpool: [],
        allowed: [],
        points: [],
        statuses: [],
      },
      status: [
        { text: "À traiter", value: "pending" },
        { text: "À calculer", value: "compute-pending" },
        { text: "Calculée", value: "calculated" },
        { text: "Problème", value: "problem" },
        { text: "Acceptée", value: "accepted" },
        { text: "Refusée", value: "rejected" },
        { text: "Annulée", value: "canceled" },
      ],
      headers: [
        {
          text: "Nom",
          value: "orderId",
          sortable: false,
        },
        {
          text: "Prénom",
          value: "value",
          sortable: false,
        },
        {
          text: "Type",
          value: "type",
          sortable: false,
        },
        {
          text: "Critères spéciaux",
          sortable: false,
        },
        {
          text: "Prioritaire",
          sortable: false,
        },
        {
          text: "Covoiturage",
          sortable: false,
        },
        {
          text: "Points",
          sortable: false,
        },
        {
          text: "Droit au macaron",
          sortable: false,
        },
        {
          text: "Statut",
          value: "status",
          sortable: false,
        },
        {
          text: "Date de création",
          value: "createdAt",
          sortable: false,
        },
        {
          text: "Commentaires",
          value: "computedValues.descr",
          sortable: false,
          align: "center",
        },
      ],
      search: "",
    };
  },
  watch: {
    selectedFilters: {
      async handler() {
        this.updateRequests();
      },
      deep: true,
    },
    year() {
      this.updateRequests();
    },
    options: {
      async handler() {
        const data = await this.getDataFromApi();
        this.requests = data.items;
        this.total = data.total;
      },
      deep: true,
    },
    dialog(after) {
      if (!after) {
        this.initialData = undefined;
      }
    },
    search: debounce(async function (value) {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${
          process.env.VUE_APP_API_URI
        }/requests?page=${page}&sortBy=${sortBy}&sortDesc=${sortDesc}&itemsPerPage=${itemsPerPage}&type=${
          this.type
        }&search=${value}&year=${this.year}&filters=${JSON.stringify(
          this.selectedFilters
        )}`,
      });

      this.loading = false;
      let { docs: items } = data;
      const total = data.totalDocs;
      this.requests = items;
      this.total = total;
    }, 500),
  },
  methods: {
    shouldHighlightTotal(editedItem) {
      return (
        editedItem.computedValues &&
        editedItem.computedValues.previousRequests &&
        editedItem.computedValues.droit_au_macaron !==
          editedItem.computedValues.previousRequests[0].droit_au_macaron &&
        editedItem.idisa !== "no-idisa"
      );
    },

    async triggerCalculation() {
      try {
        this.submitting = true;
        await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/requests/calculate`,
          data: {
            toUpdate: this.selected,
          },
        });
        this.updateRequests();
        this.selected = [];
        this.snackbar = {
          visible: true,
          color: "success",
          text: "Calcul des points effectué",
        };
      } catch (error) {
        console.log(error);
        this.snackbar = {
          visible: true,
          color: "error",
          text: "Erreur de mise à jour",
        };
        this.submitting = false;
      } finally {
        this.submitting = false;
      }
    },
    filterTable(_id) {
      this.search = _id;
      this.dialog = false;
    },
    resetFilters() {
      this.selectedFilters = {
        types: [],
        prioritary: [],
        carpool: [],
        allowed: [],
        points: [],
        statuses: [],
      };
    },
    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/requests/${this.editedItem._id}`,
        responseType: "arraybuffer",
      });
      fileDownload(
        data,
        `${this.editedItem.firstname}${this.editedItem.lastname}-recapitulatif.pdf`
      );
    },
    openSnackbar(snackbar) {
      this.snackbar = snackbar;
    },
    editItem(item) {
      this.editedIndex = this.requests.indexOf(item);
      item.updates = item.updates
        ? { _id: item._id, ...item.updates }
        : {
            address: item.address,
            idisa: item.idisa,
            firstname: item.firstname,
            lastname: item.lastname,
            email: item.email,
            type: item.type,
            unityType: item.unityType,
            studyType: item.studyType,
            unity: item.unity,
            registration: item.registration,
            carpool: item.carpool,
            carpoolers: item.carpoolers,
            children: item.children,
            childrenReason: item.childrenReason,
            corporate: item.corporate,
            corporateReason: item.corporateReason,
            health: item.health,
            site: item.site,
            _id: item._id,
          };
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    closeAdminDialog() {
      this.dialog = false;
    },
    closeFormDialog() {
      this.formDialog = false;
    },
    closeBulkdialog() {
      this.bulkDialog = false;
      this.bulkStatus = "";
      this.selectedEmail = undefined;
      this.sendEmail = false;
    },
    updateRequests() {
      this.options = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      };
    },
    async getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${
          process.env.VUE_APP_API_URI
        }/requests?page=${page}&sortBy=${sortBy}&sortDesc=${sortDesc}&itemsPerPage=${itemsPerPage}&type=${
          this.type
        }&year=${this.year}&filters=${JSON.stringify(this.selectedFilters)}`,
      });
      this.loading = false;
      let { docs: items } = data;
      const total = data.totalDocs;
      return {
        items,
        total,
      };
    },
    close() {
      this.dialog = false;
      this.sendEmail = false;
      this.selectedEmail = undefined;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.editedIndex > -1) {
        this.submitting = true;
        try {
          await axios({
            method: "patch",
            url: `${process.env.VUE_APP_API_URI}/requests/${this.editedItem._id}`,
            data: {
              comments: this.editedItem.comments,
              status: this.editedItem.status,
              deletionComments: this.editedItem.deletionComments,
              childrenValidated: this.editedItem.childrenValidated,
              corporateValidated: this.editedItem.corporateValidated,
              healthValidated: this.editedItem.healthValidated,
              updates: this.editedItem.updates,
              sendEmail:
                this.sendEmail &&
                ["accepted", "rejected"].indexOf(this.editedItem.status) > -1,
              emailContent:
                (this.selectedEmail && this.selectedEmail.html) || "",
              subject: (this.selectedEmail && this.selectedEmail.subject) || "",
            },
          });
          this.updateRequests();
          this.sendEmail = false;
          this.selectedEmail = undefined;
          this.snackbar = {
            visible: true,
            color: "success",
            text: "Demande mise à jour",
          };
          this.submitting = false;
        } catch (error) {
          console.log(error);
          this.snackbar = {
            visible: true,
            color: "error",
            text: "Erreur de mise à jour",
          };
          this.submitting = false;
        }
      }
      this.close();
    },
    async updateStatuses() {
      const status = this.bulkStatus;
      try {
        await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/statuses`,
          data: {
            toUpdate: this.selected,
            status,
            sendEmail:
              this.sendEmail && ["accepted", "rejected"].indexOf(status) > -1,
            emailContent: (this.selectedEmail && this.selectedEmail.html) || "",
            subject: (this.selectedEmail && this.selectedEmail.subject) || "",
          },
        });
        this.updateRequests();
        this.selected = [];
        this.sendEmail = false;
        this.selectedEmail = undefined;
        this.bulkDialog = false;
        this.snackbar = {
          visible: true,
          color: "success",
          text: "Statuts modifiés",
        };
      } catch (error) {
        console.log(error);
      }
    },
    checkIfPrioritary(item) {
      if (isAfter(parseISO(item.createdAt), new Date("2022-03-13"))) {
        if (
          (item.corporate &&
            item.updates.corporate &&
            item.corporateValidated) ||
          (item.health && item.updates.health && item.healthValidated) ||
          (item.studyType === "En emploi / Temps partiel" &&
            item.updates.studyType === "En emploi / Temps partiel") ||
          (item.updates.health && !item.health) ||
          (item.updates.corporate && !item.corporate) ||
          item.updates.studyType === "En emploi / Temps partiel"
        ) {
          return "OUI";
        } else if (
          (item.health && typeof item.healthValidated !== "boolean") ||
          (item.corporate && typeof item.corporateValidated !== "boolean")
        ) {
          return "-";
        } else {
          return "NON";
        }
      } else {
        if (
          (item.corporate && item.corporateValidated) ||
          (item.health && item.healthValidated) ||
          item.studyType === "En emploi / Temps partiel"
        ) {
          return "OUI";
        } else {
          if (
            (item.corporate && item.corporateValidated) ||
            (item.health && item.healthValidated) ||
            item.studyType === "En emploi / Temps partiel"
          ) {
            return "-";
          } else {
            return "NON";
          }
        }
      }
    },
  },
  filters: {
    formatDate: function (value) {
      return format(parseISO(value), "dd.MM.yyyy HH:mm");
    },
  },
};
</script>

<style>
.admin-dialog {
  box-shadow: none;
}
</style>